'use client';

import React from 'react';
import cn from 'classnames';
import staticUrls from '@framework/url/staticUrls';
import IconRotate from '@dealroadshow/uikit-icon/IconRotate';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import styles from './applicationFallback.module.scss';
import headerStyles from '@dealroadshow/uikit-styles/headers.module.scss';
import screenWithWarning from './assets/screen-with-warning.svg';

const onReloadClick = () => window.location.reload();

const ApplicationFallback = () => (
  <div className={ cn(styles.container) }>
    <ScrollBodyBackground tenant="fallback" />

    <img
      src={ screenWithWarning.src }
      alt="Something went wrong"
    />

    <div className={ styles.messageWrapper }>
      <h1 className={ cn(styles.messageHeader, headerStyles.isH1) }>
        Something went wrong
      </h1>
      <div className={ styles.message }>
        Please <a href={ staticUrls.getContactUsUrl() }>contact</a> support or reload
      </div>
      <div className={ styles.reloadWrapper }>
        <a
          className={ styles.reloadLink }
          onClick={ onReloadClick }
        >
          <IconRotate className={ styles.reloadIcon } />
          Reload
        </a>
      </div>
    </div>
  </div>
);

export default ApplicationFallback;
